import React, { createContext, useContext } from 'react'

export const SettingsContext = createContext(null)

export const useSettings = () => {
  const context = useContext(SettingsContext)
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider')
  }
  return context
}

export const useAppSettings = () => {
  const { appSettings } = useSettings()
  return appSettings
}

export const useBrand = () => {
  const { brandSettings } = useSettings()
  return brandSettings
}

const SettingsProvider = ({ children, appSettings, brandSettings }) => {
  const settingsData = {
    appSettings,
    brandSettings
  }

  return (
    <SettingsContext.Provider value={settingsData}>
      {children}
    </SettingsContext.Provider>
  )
}

export default SettingsProvider
